export enum Environments {
  boticario = 'catalogo-boticario',
  eudora = 'guia-eudora',
  boticarioReseller = 'catalogo-boticario-revendedora',
  notSet = 'nao-informado',
}

export enum EnhancedEcommerceEvents {
  productClick = 'productClick',
  productDetail = 'productDetail',
  productImpressions = 'productImpressions',
}

export interface IEnhancedEcommerceProduct {
  name: string;
  id: string;
  price: number;
  brand: string;
  category: string;
  list?: string;
  position?: number;
}

export interface IEnhancedEcommerce {
  click?: {
    actionField: {
      list: string;
    };
    products: [IEnhancedEcommerceProduct];
  };
  detail?: {
    products: [IEnhancedEcommerceProduct];
  };
  impressions?: IEnhancedEcommerceProduct[];
}

export interface IEnhancedEcommerceEvent {
  event: EnhancedEcommerceEvents;
  ambiente: Environments;
  ecommerce: IEnhancedEcommerce;
}
